<template>
  <!-- 骑行信息 -->
  <div class="ride">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form
        ref="form"
        :model="searchParams"
        label-width="auto"
        class="from"
        size="small"
      >
        <el-form-item :label="$t('pages.user.text30')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton type="search" @click="search"></DiluButton>
        <DiluButton type="reset" @click="reset"></DiluButton>
      </div>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="list"
      :tableConfig="tableConfig"
      :total="total"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
    >
      <el-table-column prop="account" label="#" width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ridingTime"
        :label="
          $t('pages.user.text19') +
          '(' +
          $t('pages.user.text28') +
          '/' +
          $t('pages.user.text29') +
          ')'
        "
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <div>{{ scope.row.startRidingTime }}</div>
            <div>{{ scope.row.stopRidingTime }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="ridingDistance"
        :label="$t('pages.user.text6')"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.ridingDistance }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="ridingTime"
        :label="$t('pages.user.text26')"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.ridingTime }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="averageSpeed"
        :label="$t('pages.user.text25')"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.averageSpeed }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="operateTime"
        :label="$t('public.text4')"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="ridingTrack(scope.row)" type="text">{{
              $t("pages.user.text24")
            }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <el-dialog
      :title="$t('pages.user.text24')"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="dialogClose"
      :close-on-click-modal="false"
    >
      <div class="map-content">
        <MapRiding :trackData="trackData" :dialogVisible="dialogVisible" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">{{ $t("button.cancel") }}</el-button>
        <el-button type="primary" @click="dialogClose">{{
          $t("button.determine")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../../components/pubilc/dilu-table.vue";
import { resetDate } from "../../../../utils/util/validate";
import MapRiding from "./mapRiding.vue";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      dialogVisible: false,
      searchParams: {
        appUserId: "",
        pageNum: 1,
        pageSize: 10,
        startAt: "",
        stopAt: "",
      },
      tableConfig: {
        isTree: false,
        isTreeText: "id",
        isPage: true,
      },
      trackData: [],
      total: 0,
      list: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluButton,
    DiluTable,
    // MapDialog,
    MapRiding,
  },
  watch: {
    activeName(newValue) {
      if (newValue == "third") {
        this.searchParams.appUserId = this.currentUser.id;
        this.getTrackDataByAppUserId();
      }
    },
  },
  props: ["activeName", "currentUser"],
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.getTrackDataByAppUserId();
    },
    startChange() {
      this.searchParams.stopAt = null;
    },
    ridingTrack(e) {
      // console.log(e.startCoordinate);
      // console.log(e.stopCoordinate);
      let arr = JSON.parse(e.trackData);
      // let arr1 = [];
      // this.trackData = JSON.parse(e.trackData);
      if (arr.length < 1) {
        arr[0] = e.startCoordinate.split(",");
        arr[1] = e.stopCoordinate.split(",");
        arr[0][0] = Number(arr[0][0]);
        arr[0][1] = Number(arr[0][1]);
        arr[1][0] = Number(arr[1][0]);
        arr[1][1] = Number(arr[1][1]);
      }
      console.log(arr);
      this.trackData = arr;
      this.dialogVisible = true;
    },
    dialogClose() {
      this.dialogVisible = false;
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        appUserId: this.currentUser.id,
        pageNum: 1,
        pageSize: 10,
        startAt: "",
        stopAt: "",
      };
      this.getTrackDataByAppUserId();
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          appUserId: this.currentUser.id,
          pageNum: 1,
          pageSize: 10,
          startAt: "",
          stopAt: "",
        };
      }
      this.searchParams.pageNum = e;
      this.getTrackDataByAppUserId();
    },
    //获取骑行信息数据
    getTrackDataByAppUserId() {
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      this.request.getTrackDataByAppUserId(this.searchParams).then((res) => {
        this.list = res.data;
        this.total = res.dataMaxCount;
      });
    },
  },
};
</script>


<style scoped>
.ride {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
.searchSubmit {
  float: right;
  display: flex;
  align-items: center;
}
.map-content {
  width: 100%;
  height: 500px;
}
</style>